module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "foot_top"
  }, [_c('div', {
    staticClass: "foot_top_left"
  }, [_c('div', {
    staticClass: "foot_top_left_cent"
  }, [_vm._v(_vm._s(_vm.common.company_name))]), _vm._v(" "), _c('div', {
    staticClass: "foot_top_left_cent"
  }, [_vm._v("联系邮箱：" + _vm._s(_vm.common.email))]), _vm._v(" "), _c('div', {
    staticClass: "foot_top_left_cent"
  }, [_vm._v("联系电话：" + _vm._s(_vm.common.phone))]), _vm._v(" "), _c('div', {
    staticClass: "foot_top_left_cent"
  }, [_vm._v("联系地址：" + _vm._s(_vm.common.address))])]), _vm._v(" "), _c('img', {
    staticClass: "foot_top_right",
    attrs: {
      "src": require("../../assets/images/qie/6.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "foot_bottom"
  }, [_c('div', {
    staticClass: "foot_bottom_tt"
  }, [_vm._v("版权所有：" + _vm._s(_vm.common.copyright))]), _vm._v(" "), _c('div', {
    staticClass: "foot_bottom_tt",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.jump
    }
  }, [_vm._v("备案号：" + _vm._s(_vm.common.filing_no))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62edd1c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foot/footer.vue
// module id = 895
// module chunks = 1